import { render, staticRenderFns } from "./WorkoutDetail.vue?vue&type=template&id=33057b65&"
import script from "./WorkoutDetail.vue?vue&type=script&lang=js&"
export * from "./WorkoutDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports